import { render, staticRenderFns } from "./CanvasArrowsNavigation.vue?vue&type=template&id=78a1aa8a&scoped=true"
import script from "./CanvasArrowsNavigation.vue?vue&type=script&lang=js"
export * from "./CanvasArrowsNavigation.vue?vue&type=script&lang=js"
import style0 from "./CanvasArrowsNavigation.vue?vue&type=style&index=0&id=78a1aa8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a1aa8a",
  null
  
)

export default component.exports